module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/money_200_eur-a82b61cb1b928395e7fbedb12ca3044c.png";